<template>
  <div class="about1">
    <!-- 企业简介 -->
    <div class="about1-dis">
        <div class="left">
          <video v-if="isEnglish" style="width: 100%;height: 100%;object-fit:" src="https://official-web-static.womucloud.com/company_intro_en.mp4" controls muted autoplay loop></video>
          <video v-else style="width: 100%;height: 100%;object-fit:" src="https://official-web-static.womucloud.com/company_intro_zh.mp4" controls muted autoplay loop></video>
          </div>
        <div class="right" v-if="isEnglish">
          <p>Warm&Cozy Technology is an AI-powered innovation company dedicated to the digital transformation of energy and traditional industries. Our complete technology framework spans the entire chain—from perception layer and IoT platforms to data hubs and AI-powered applications—helping enterprises unlock smarter, more efficient, and sustainable operations.
            Through the Mootech product series and three intelligent assistants—Moopilot (for executives), Moodesk (for employees), and Mooaura (for customer service)—we provide practical AI solutions that streamline work, cut costs, and enhance customer experience.
          </p>
          <p>Beyond solving immediate challenges in automation, monitoring, and control, our solutions prepare enterprises for the next 3–5 years of AI-driven transformation. Guided by our values of Innovation, Reliability, and Win-win Collaboration, Warm&Cozy integrates deep industry expertise with cutting-edge AI to create sustainable growth for businesses and cities.</p>
        </div>

        <div class="right" v-else>
          <p>沃慕科技（Warm&Cozy）是一家专注于能源与传统行业数字化升级的 AI 创新企业，提供软硬件一体化智能解决方案，覆盖智慧供热、水务和能源等关键领域。我们打造了从感知层、IoT 平台、数据中台到 AI 应用的完整技术体系，推出了 Mootech 系列核心产品与三大智能助手——Moopilot（高管助手）、Moodesk（员工助手）、Mooaura（客服助手），助力企业实现高效运营、智能决策与卓越服务。</p>
          <p>我们的使命是 以 AI 赋能能源与城市，使其更智慧、更高效、更可持续；愿景是 成为全球领先的 AI 驱动企业数字化引擎。我们秉持 创新、可靠、共赢合作 的价值观，携手客户与伙伴，共同推动产业转型与未来发展。</p>
        </div>
    </div>
    <!-- 企业文化 -->
    <div class="cultural"   v-if="isEnglish">
      <h1>Corporate Culture</h1>
      <div style="margin-bottom: 4em;" class="mission">
        <h2>Mission</h2>
        <p style="text-align: center;">Empower energy and cities with AI—smarter, more efficient, and sustainable.</p>
      </div>
      <div style="margin-bottom: 4em;" class="vision">
        <h2>Vision</h2>
        <p style="text-align: center;">Making AI the new driver of energy and traditional industries, to make businesses efficient, life comfortable, and the world better.</p>
      </div>
      <div class="core_Values">
        <h2>Values</h2>
        <p style="text-align: center;">Innovation: Pushing boundaries, AI-driven change</p>
        <p style="text-align: center;">Reliability: Stable, secure, trusted quality</p>
        <p style="text-align: center;">Win-win: Partnering for shared success</p>
        <p style="text-align: center;">Service: Customer-focused, efficient, experience-driven</p>
        <p style="text-align: center;">Growth: Learning together, continuous progress</p>
      </div>
    </div>
    <div class="cultural"  v-else>
      <h1>企业文化</h1>
      <div style="margin-bottom: 4em;" class="mission">
        <h2>使命</h2>
        <p style="text-align: center;">用 AI 让能源与城市更智能、更高效、更可持续</p>
      </div>
      <div style="margin-bottom: 4em;" class="vision">
        <h2>愿景</h2>
        <p style="text-align: center;">让 AI 成为能源和传统行业的新动力，助力企业更高效，生活更舒适，世界更美好</p>
      </div>
      <div class="core_Values">
        <h2>价值观</h2>
        <p style="text-align: center;">创新 ：突破边界，用 AI 驱动变革</p>
        <p style="text-align: center;">可靠 ：稳定安全，品质保障</p>
        <p style="text-align: center;">共赢 ：携手合作，共创未来</p>
        <p style="text-align: center;">服务 ：以客户为中心，专注高效与体验</p>
        <p style="text-align: center;">成长 ：共同学习，不断提升</p>
      </div>
    </div>
  </div>
</template>

<script setup name="AboutAccompany">
import { computed } from 'vue'

const isEnglish = computed(() => {
  return window.location.pathname.startsWith('/en')
})
</script>

<style scoped>
.about1{
  width: 90%;
  margin: 4em auto;
  margin-bottom: 0;
}
.about1-dis {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.right{
  width: 60%;
  background-color: #fff;
}
.right p{
  text-indent: 2em;
  line-height: 2em;
}
.left{
  width: 50%;
  height: 26em;
  background-color: #575353;
  margin-right: 2em;
}
.about-culture{
  width: 100%;
  margin:3em auto;
}
.about-cu{
  display: flex;
}
.cu-left>ul{
  display: flex;
  flex-direction: column;
  align-content: flex-end;
}
.cu-left>ul>li{
  list-style: none;
  margin-top: 2em;
  text-align: right;
}
.cu-left>ul li h4{
  margin-right: 2em;
}
.cu-right p,.cu-right ul{
  margin-top: 2em;
}
.cu-right>ul>li{
  list-style: none;
  margin-bottom: 0.5em;
}
.about-graph .box{
  min-width: 20em;
  min-height: 20em;
  background-color: #575353;
}
.cultural{
  width: 100%;
  margin: 4em auto;
}
.cultural h1{
  text-align: center;
  margin-bottom: 2em ;
}
.mission,.vision,.core_Values{
  width: 100%;
  margin: 2em auto;
}
.mission h2,.vision h2,.core_Values h2{
  text-align: center;
  margin-bottom: 1em;
}
.mission p,.vision p,.core_Values p{
  text-indent: 2em;
  line-height: 2em;
  margin-bottom: 1em;
}
@media (max-width: 768px){
  .about1-dis {
  display: block !important;
}
.left,.right{
  width: 100%;
  margin-top: 1em;
}
.left{
  height: 20em;
}
.right p{
  text-indent: 2em;
  line-height: 2em;
  font-size: 0.8em;
}
.about-culture{
  margin: 1em auto;
}
.cultural>h1{
  font-size: 1.2em;
  margin-bottom: 0;
}
.mission,.vision,.core_Values{
  margin: 1em auto;
}
.mission h2,.vision h2,.core_Values h2{
  font-size: 1em;
  text-align: center;
  margin-bottom: 0.5em;
}
.mission p,.vision p,.core_Values p{
  font-size: 0.8em;
  text-indent: 2em;
  line-height: 2em;
  margin-bottom: 1em;
}

}
</style>